import { useLocation, Link, useNavigate } from "react-router";
import { translate } from "../translations/index";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import logo from "../images/logo.png";
import { useState } from "react";
import usageGuide from "../assets/docs/debatlab in de praktijk.pdf";
import { localStorage } from "../utils";

export default function Header() {
  const [expanded, setExpanded] = useState(false);
  const { pathname: currentPath } = useLocation();
  const navigate = useNavigate();

  const userRole = localStorage.getItem("role");
  const isLoggedIn = localStorage.getItem("jwt-token");

  const homepage = currentPath === "/";

  const logout = () => {
    localStorage.removeItem("jwt-token");
    localStorage.removeItem("role");
    navigate("/");
  };

  return (
    <header
      className={clsx("header", {
        "header--expanded": expanded,
        "header--homepage": homepage,
      })}
      {...(currentPath.includes("/teacher/votingsession") && {
        style: { position: "absolute" },
      })}
    >
      <div className="header__logo-wrapper">
        <Link to="/">
          <img
            className={"header__logo"}
            src={logo}
            alt={translate("layout.header.logoAlt")}
          />
        </Link>
        {/* TODO: Make into button! */}
        <div className="header__menu-toggle">
          {expanded ? (
            <CloseIcon fontSize="large" onClick={() => setExpanded(false)} />
          ) : (
            <MenuIcon fontSize="large" onClick={() => setExpanded(true)} />
          )}
        </div>
      </div>

      <nav className="header__nav">
        <Link
          className="header__link header__link--home"
          aria-current={currentPath === "/" ? "page" : false}
          to="/"
        >
          {translate("layout.header.home")}
        </Link>
        <a
          className="header__link header__link--guide"
          href={usageGuide}
          target="_blank"
          rel="noreferrer"
        >
          {translate("layout.header.inPractice")}
        </a>
        <Link className="header__link header__link--guide" to="/user-guide">
          {translate("layout.header.userManual")}
        </Link>
        <Link
          className="header__link header__link--about"
          aria-current={currentPath === "/about" ? "page" : false}
          to="/about"
        >
          {translate("layout.header.about")}
        </Link>

        <div className="header__button-group">
          {userRole &&
            ["teacher", "admin", "super_admin"].includes(userRole) && (
              <Link to={"/teacher"} className="button button--sm">
                {translate("layout.header.teacher")}
              </Link>
            )}
          {userRole && ["admin", "super_admin"].includes(userRole) && (
            <Link className="button button--sm" to={"/admin"}>
              {translate("layout.header.admin")}
            </Link>
          )}
          {isLoggedIn && (
            <button
              className="button button--outline button--sm"
              onClick={logout}
            >
              {translate("layout.header.logout")}
            </button>
          )}
          {!isLoggedIn && (
            <Link className="button button--outline button--sm" to={"/login"}>
              {translate("layout.header.login")}
            </Link>
          )}
        </div>
      </nav>
    </header>
  );
}
